var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "32px",
    viewBox: "0 0 12 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.0777484%",
    cy: "26.2590906%",
    fx: "50.0777484%",
    fy: "26.2590906%",
    r: "86.178349%",
    gradientTransform: "translate(0.500777,0.262591),scale(1.000000,0.855678),rotate(90.000000),translate(-0.500777,-0.262591)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2DE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav/Top-Primary",
    transform: "translate(-1411.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Primary-Nav"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mode-Switch",
    transform: "translate(1394.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LAmp",
    transform: "translate(17.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,12.6291375 C2,11.0587625 2.66453526e-15,10.1144916 2.66453526e-15,5.8835695 C2.82235113e-15,2.63416379 2.6862915,4.17443857e-14 6,4.17443857e-14 C9.3137085,4.17443857e-14 12,2.63416379 12,5.8835695 C12,10.1144916 10,11.0587625 10,12.6291375 C10,13.4004247 10,13.8653684 10,14.0239685 L2,14.0239685 C2,13.8653684 2,13.4004247 2,12.6291375 Z",
    id: "Path",
    fill: "url(#radialGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,15 L10,15 C10,15.3193026 10,15.775816 10,16.3695401 C10,16.3695401 10,16.3695401 10,16.3695401 L10,16.3695401 C10,17.822303 8.82230298,19 7.36954008,19 L4.63045992,19 C3.17769702,19 2,17.822303 2,16.3695401 L2,15 Z",
    id: "Rectangle",
    fill: "#8B9CAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,19.5 L6,28",
    id: "Path-3",
    stroke: "#445A6C",
    strokeDasharray: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#C5D2DE",
    strokeWidth: 1.5,
    fill: "#1C252D",
    cx: 6,
    cy: 28,
    r: 3
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.9f7d52cbec1076b8a531426de5c130c1.svg";
export { ForwardRef as ReactComponent };